if (!Object.prototype.hasUndefinedProperty) {
  Object.defineProperty(Object.prototype, 'hasUndefinedProperty', {
    value: function () {
      for (var key in this) {
        if (Object.hasOwnProperty.call(this, key) && typeof this[key] === 'undefined') {
          return true;
        }
      }
      return false;
    },
    enumerable: false,
  });
}
